<template>
  <div>
    <Row class="top" justify="space-between" :gutter="16">
      <Col span="8" class="col">
      <div class="price">
        <p class="p1">{{ formattedPrice.price1 }}</p>
        <div class="text">
          <p>年度预算</p>
        </div>
      </div>
      </Col>
      <Col span="8" class="col">
      <div class="price">
        <p class="p2">{{ formattedPrice.price2 }}</p>
        <div class="text">
          <p>完成招标</p>
        </div>
      </div>
      </Col>
      <Col span="8" class="col">
      <div>
        <div class="price">
          <p class="p3">{{ price3 }}</p>
          <div class="text">
            <p>完成建设</p>
          </div>
        </div>
      </div>
      </Col>
    </Row>
    <Row class="top_nav" justify="space-between" :gutter="16">
      <Col span="6" class="col">
      <div class="price" @click="onGoTo(1)">
        <p class="p1">{{ noInvoiceData }}</p>
        <div class="text">
          <p>待开票</p>
        </div>
      </div>
      </Col>
      <Col span="6" class="col">
      <div class="price" @click="onGoTo(2)">
        <p class="p2">{{ invoiceData }}</p>
        <div class="text">
          <p>已开票</p>
        </div>
      </div>
      </Col>
      <Col span="6" class="col">
      <div class="price" @click="onGoTo(4)">
        <p class="p3">{{ transferOfFinance }}</p>
        <div class="text">
          <p>移交财务</p>
        </div>
      </div>
      </Col>
      <Col span="6" class="col">
      <div class="price" @click="onGoTo(5)">
        <p class="p4">{{ havePaid }}</p>
        <div class="text">
          <p>已支付</p>
        </div>
      </div>
      </Col>
    </Row>
    <div class="bottom">
      <Row justify="space-between" :gutter="16">
        <Col span="12">
        <div class="b-left">
          <LeftPage :chartData="chartData1" :chartLabels="chartLabels1" chartHeight="500px" />
        </div>
        </Col>
        <Col span="12">
        <div class="b-right">
          <RightPage :chartData="chartData2" :chartLabels="chartLabels2" chartHeight="500px" />
        </div>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import LeftPage from "./activitylist/leftPage.vue";
import RightPage from "./activitylist/rightPage.vue";
import dayjs from "dayjs";
export default {
  components: {
    LeftPage,
    RightPage,
  },
  data() {
    return {
      chartData1: [],
      chartLabels1: [],
      chartData2: [],
      chartLabels2: [],
      price1: 0,
      price2: 0,
      price3: 0,
      noInvoiceData: 0,
      invoiceData: 0,
      transferOfFinance: 0,
      havePaid: 0,
    };
  },
  created() {
    this.curYearData();
    this.tongji();
    this.zhexian();
    this.loadInvoiceData()
  },
  computed: {
    formattedPrice() {
      return {
        price1: this.formatPrice(this.price1),
        price2: this.formatPrice(this.price2),
      };
    },
  },
  methods: {
    onGoTo(value) {
      if (value == 1) {
        $utils.url.push({ name: 'invoice_List', query: { isValue: 1 } })
      }
      if (value == 2) {
        $utils.url.push({ name: 'invoice_List', query: { isValue: 2 } })
      }
      if (value == 4) {
        $utils.url.push({ name: 'invoice_List', query: { isValue: 4 } })
      }
      if (value == 5) {
        $utils.url.push({ name: 'invoice_List', query: { isValue: 5 } })
      }
    },
    async loadInvoiceData() {
      let q = {}
      let res = await $utils.api.load('/admin/system/invoice/invoiceData', q, 'get')
      console.log(res);
      if (res.code == 200) {
        let arr = res.data
        arr.forEach(item => {
          if (item.name == "未开票") {
            this.noInvoiceData = item.value
          }
          if (item.name == "已开票") {
            this.invoiceData = item.value
          }
          if (item.name == "移交财务") {
            this.transferOfFinance = item.value
          }
          if (item.name == "已支付") {
            this.havePaid = item.value
          }
        });
      }

    },
    formatPrice(price) {
      return `¥${price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
    },
    async curYearData() {
      let q = {
        begin: dayjs().startOf("year").format("YYYY-MM-DD HH:mm:ss"),
        end: dayjs().endOf('years').format("YYYY-MM-DD HH:mm:ss"),
      };
      let res = await $utils.api.load("/admin/system/management/curYearData", q, "get");
      if (res.code == 200) {
        let data = res.data;
        this.price1 = data[1].value;
        this.price2 = data[2].value;
        this.price3 = data[3].value;
      }
    },
    async tongji() {
      let q = {
        begin: dayjs().startOf("year").format("YYYY-MM-DD HH:mm:ss"),
        end: dayjs().endOf('years').format("YYYY-MM-DD HH:mm:ss"),
        value: 2,
      };
      let res = await $utils.api.load(
        "/admin/system/management/curYearDataType",
        q,
        "get"
      );
      if (res.code == 200) {
        let data = res.data;
        this.chartLabels1 = data.map((item) => item.totalMoney);
        this.chartData1 = data.map((item) => item.name);
      }
    },
    async zhexian() {
      let q = {
        begin: dayjs().startOf("year").format("YYYY-MM-DD HH:mm:ss"),
        end: dayjs().endOf('years').format("YYYY-MM-DD HH:mm:ss"),
        value: 2,
      };
      let res = await $utils.api.load(
        "/admin/system/management/curYearDataSchedule",
        q,
        "get"
      );
      if (res.code == 200) {
        let data = res.data;
        this.chartLabels2 = data.map((item) => item.totalMoney);
        this.chartData2 = data.map((item) => item.name);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.top {
  .price {
    box-shadow: 0px 0px 7px 3px rgba(215, 214, 214, 0.5);
    border-radius: 5px;

    .text {
      border-top: 1px solid #e8eaec;

      p {
        padding: 5px 0;
        font-size: 18px;
        color: #515a6e;
      }
    }

    .p1 {
      padding: 20px 0 10px 0;
      font-size: 1.7rem;
      color: #69c0ff;
    }

    .p2 {
      padding: 20px 0 10px 0;
      font-size: 1.7rem;
      color: #95de64;
    }

    .p3 {
      padding: 20px 0 10px 0;
      font-size: 1.7rem;
      color: #ff9c6e;
    }
  }

  .col {
    text-align: center;
  }
}

.top_nav {
  margin-top: 20px;

  .price {
    box-shadow: 0px 0px 7px 3px rgba(215, 214, 214, 0.5);
    border-radius: 5px;

    .text {
      border-top: 1px solid #e8eaec;

      p {
        padding: 5px 0;
        font-size: 18px;
        color: #515a6e;
      }
    }

    .p1 {
      padding: 20px 0 10px 0;
      font-size: 1.7rem;
      color: #69c0ff;
    }

    .p2 {
      padding: 20px 0 10px 0;
      font-size: 1.7rem;
      color: #95de64;
    }

    .p3 {
      padding: 20px 0 10px 0;
      font-size: 1.7rem;
      color: #ff9c6e;
    }

    .p4 {
      padding: 20px 0 10px 0;
      font-size: 1.7rem;
      color: #ff0000;
    }
  }

  .col {
    text-align: center;
  }
}

.ivu-card {
  box-shadow: 0px 0px 10px 5px rgba(128, 128, 128, 0.5);
}

.bottom {
  margin-top: 20px;
}
</style>
